import { paymentsAxios } from 'services/controllers/payments';

import * as t from './types';

export const PaymentsApi = {
  getPaymentsHistory: async (params: t.IGetPaymentsHistoryParams) => {
    const { data } = await paymentsAxios.get<t.IGetPaymentsHistoryResponse>('', { params });
    return data;
  },

  getPaymentMethod: async () => {
    const { data } = await paymentsAxios.get<t.IGetPaymentMethodResponse>('/payment-method');
    return data;
  },

  getUrlToChangePaymentMethod: async () => {
    const { data } = await paymentsAxios.get<t.IGetUrlToChangePaymentMethodResponse>('/billing');
    return data;
  }
};
